"use client";

import Link from "next/link";
import { ThemeSwitcher } from "@/components/ThemeSwitcher";

const navLinks = [
  { href: "/blog", label: "Blog" },
  { href: "/works", label: "作品" },
  { href: "/skills", label: "Skills" },
  { href: "/projects", label: "Projects" },
  { href: "/about", label: "About" },
];

export function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-sm">
      <div className="mx-auto flex h-14 max-w-4xl items-center justify-between px-4">
        <Link href="/" className="font-mono text-lg font-bold tracking-tight">
          <span className="text-theme-accent">☆</span> 长庚
        </Link>

        {/* Mobile nav — always visible */}
        <nav className="flex items-center gap-4 md:hidden">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-sm text-muted-foreground transition-colors hover:text-theme-accent"
            >
              {link.label}
            </Link>
          ))}
          <ThemeSwitcher />
        </nav>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-6 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-sm text-muted-foreground transition-colors hover:text-theme-accent"
            >
              {link.label}
            </Link>
          ))}
          <ThemeSwitcher />
        </nav>
      </div>
    </header>
  );
}
